export default __webpack_public_path__ + "static/media/p14.c0a7caeb.jpg";